import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class CustomIcon extends React.PureComponent {

    static propTypes = {
        iconName: PropTypes.string.isRequired,
        iconPosition: PropTypes.string
    }

    render() {
        let defaultClasses = {
            "custom-icon": true
        };

        defaultClasses["icon-" + this.props.iconName] = true;

        if (this.props.iconPosition) {
            defaultClasses["icon-" + this.props.iconPosition] = true;
        }

        return (
            <i className={classNames(defaultClasses)} />
        );
    }

}

export default CustomIcon;
